import { combineReducers } from 'redux';
import OfficersReducer from './officers/reducer';

export default combineReducers({
    Officers: OfficersReducer,
});
